import React, { Component } from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';

import configureStore from './store/configureStore';
import TryApp from './containers/TryApp';

const store = configureStore();

export default class App extends Component {
  render() {
    return (
      <Provider store={store}>
          <TryApp {...this.props} />
      </Provider>
    );
  }
}
